module.exports = __webpack_public_path__ + "img/spain.b42e0b8.jpg";